import { GrTicket } from 'react-icons/gr';
import { BiParty } from 'react-icons/bi';
import { BiCloset } from 'react-icons/bi';
import { LiaCocktailSolid } from 'react-icons/lia';
import { MdOutlineFastfood } from 'react-icons/md';
import { FaCar } from 'react-icons/fa';
import { FaSmoking } from 'react-icons/fa';
import { PiBeerBottleBold } from 'react-icons/pi';
import { MdEmojiPeople } from 'react-icons/md';
import { FaRegStar } from 'react-icons/fa';

const getImage = (name: string) => {
  switch (name.toLowerCase()) {
    case 'reservas':
      return <GrTicket size={32} />;
    case 'eventos':
      return <BiParty size={32} />;
    case 'vestier':
      return <BiCloset size={32} />;
    case 'cocteleria':
      return <LiaCocktailSolid size={38} />;
    case 'comida':
      return <MdOutlineFastfood size={32} />;
    case 'estacionamiento':
      return <FaCar size={32} />;
    case 'área de fumadores':
      return <FaSmoking size={32} />;
    case 'barra libre':
      return <PiBeerBottleBold size={32} />;

    case 'servicio a la mesa':
      return <MdEmojiPeople size={32} />;
    default:
      return <FaRegStar size={32} />;
  }
};

const ServiceItem = ({ name }) => {
  return (
    <div className="flex items-center gap-1">
      <div className="w-12 h-11 flex items-center ">{getImage(name)}</div>
      <div className="text-sm flex items-center h-full">{name}</div>
    </div>
  );
};

export default ServiceItem;
